import * as Sentry from '@sentry/react';

const isTestMode = import.meta.env.MODE === 'test';
const isDevelopmentMode = import.meta.env.MODE === 'development';
const isDevSentryEnabled =
  import.meta.env.REACT_APP_SENTRY_ENABLE_IN_DEV === 'true';
const sentryDsn =
  import.meta.env.REACT_APP_SENTRY_DSN ||
  'https://c6a7fde39f696ad42214f9e9e3323371@o4510907225735168.ingest.de.sentry.io/4510907238907984';

declare global {
  interface Window {
    __optimisticNewsSentryInitialized?: boolean;
  }
}

export function initSentryLazy(): void {
  if (isTestMode) return;
  if (typeof window === 'undefined') return;
  if (window.__optimisticNewsSentryInitialized) return;

  if (isDevelopmentMode && !isDevSentryEnabled) {
    window.__optimisticNewsSentryInitialized = true;
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/optimistic-news\.com/,
      /^https:\/\/www\.optimistic-news\.com/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });

  window.__optimisticNewsSentryInitialized = true;
}

export { Sentry };
